import styled from '@emotion/styled'
import { colors } from '../../../styles/theme'

const S = {}

S.Input = styled.input`
  position: relative;
  width: 100%;
  background-color: transparent;
  color: ${colors.white};
  font: inherit;
  border: none;
  padding-block: 0.25rem;

  &:focus {
    outline: none;
  }

  &:disabled {
    color: ${colors.scarpaFlow};
  }

  &:readonly {
    color: ${colors.silverChalice};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
`

S.ResetIcon = styled.div`
  position: absolute;
  cursor: pointer;
  display: inline-flex;
  inset-inline-end: 0.0625rem;
  bottom: 0.3125rem;
  height: 1rem;
  width: 1rem;
  padding: 0.125rem;
  border: 0.25rem solid;
  border-color: ${({ isResetFocused }) =>
    isResetFocused ? colors.silverChalice : 'transparent'};

  &:focus {
    outline: none;
  }

  .reset-icon {
    height: 100%;
    width: 100%;
    color: ${colors.black};
    fill: ${colors.black};
    background-color: ${colors.silverChalice};
    border-radius: 50%;

    &:focus {
      outline: none;
    }
  }
`

export default S
